<template>
  <div>
    <h1
      id="createAppTitle"
      class="text-center mb-1"
    >
      {{ $t('apps.createApp') }}
    </h1>
    <p class="text-center mb-2">
      {{ $t('apps.provideApplicationDataWithThisForm') }}
    </p>
    <div class="p-1">
      <validation-observer ref="add_app_form">
        <b-row class="mb-1">
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              :name="$t('apps.appName')"
              vid="app name"
              :rules="{ required: true, min: 3, max: 100}"
            >
              <label for="app_name_input"><h5>{{ $t('apps.appName') }}</h5></label>
              <b-form-input
                id="app_name_input"
                v-model="app_name"
                :placeholder="$t('apps.appName')"
              />
              <small
                v-if="errors.length > 0"
                class="text-danger"
              >{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              :name="$t('apps.appUrl')"
              vid="app url"
              :rules="{ required: true, url: true }"
            >
              <label for="app_url_input"><h5>{{ $t('apps.appUrl') }}</h5></label>
              <b-form-input
                id="app_url_input"
                v-model="app_url"
                :placeholder="$t('apps.exampleHttpMydomainCom')"
              />
              <small
                v-if="errors.length > 0"
                class="text-danger"
              >{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              :name="$t('apps.currencyName')"
              vid="currency name"
              :rules="{ required: true, min: 1, max: 20 }"
            >
              <label for="currency_name_input"><h5>{{ $t('apps.currencyName') }}</h5></label>
              <b-form-input
                id="currency_name_input"
                v-model="currency_name"
                :placeholder="$t('apps.exampleDiamondsCoinsCredits')"
              />
              <small
                v-if="errors.length > 0"
                class="text-danger"
              >{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
    </div>
    <div
      class=" px-3 py-2"
      style="text-align: center;"
    >
      <b-button
        variant="primary"
        class="mr-1"
        @click="submitData"
      >{{ $t('apps.submit') }}
      </b-button>
    </div>
  </div>
</template>
<script>
import i18n from '@/libs/i18n'

import { extend, ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full'

extend('url', {
  validate(value) {
    return /^((?:https?:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)$/.test(value)
  },
  message: (field, parameters) => i18n.t('apps.thisValueMustBeAValidUrl', { ...parameters, _field_: field }),
})
export default {
  name: 'AddNewApp',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    data: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      app_name: '',
      app_url: '',
      currency_name: '',
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    }
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
  },
  methods: {
    submitData() {
      this.$refs.add_app_form.handleSubmit(() => {
        const obj = {
          name: this.app_name,
          url: this.app_url,
          currency_name: this.currency_name,
        }
        this.showLoading()
        this.$http
          .post('/api/apps', obj)
          .then(response => {
            const statusCode = response.response ? response.response.status : null
            if (statusCode === null || statusCode === 200) {
              this.reset()
              this.$emit('added_app', response.data)
              this.$bvModal.hide('modal-add-new-app')
            }
          })
          .finally(() => {
            this.hideLoading()
          })
      })
    },
    reset() {
      this.app_name = ''
      this.app_url = ''
      this.currency_name = ''
    },
  },
}
</script>
